import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CardsLayoutType, PlaylistCardShort } from '@app/app/shared/models';

@Component({
  selector: 'ptl-card-item',
  templateUrl: './card-item.component.html',
  styleUrls: ['./card-item.component.scss'],
})
export class CardItemComponent {
  @Input() card: PlaylistCardShort;
  @Input() viewType: CardsLayoutType = 'CardView';

  @Output() cardClick = new EventEmitter<PlaylistCardShort>();
}
